import { trackPostHogEvent } from "@/lib/posthog";

/** Allow-list only: no names, emails, usernames, household ids, card or invoice data. */
const ALLOWED = new Set(["plan_tier", "cadence", "seat_used", "seat_max", "learner_intent", "outcome", "reason_code", "surface"]);

export function sanitizeSeatTelemetry(props: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(props)) {
    if (ALLOWED.has(k) && (typeof v === "string" || typeof v === "number" || typeof v === "boolean")) out[k] = v;
  }
  return out;
}

export function trackSeatEvent(name: string, props: Record<string, unknown> = {}) {
  trackPostHogEvent(name, sanitizeSeatTelemetry(props));
}
